import React from "react"
import Affiliates from "./AffiliatesPage/Affiliates"
import BubblesBg from "./BubblesBg/BubblesBg"

function AffiliatesPage() {
  return (
    <>
      <Affiliates />
      <BubblesBg/>
    </>
  )
}

export default AffiliatesPage